import analytics from '@cvent/analytics';
import getEnvVar from 'utils/getEnvVar';
import { getInstance as getBootstrap } from 'utils/bootstrap';
import Logger from './Logger';
import { BUSINESS_UNIT, DD_HOST_SERVICE_NAME, PRODUCT } from './constants';
import { getEnvironmentName } from './datadogConfig';

const LOG = new Logger('initAnalytics');
const DATA_PLATFORM_URL_DEV = 'https://cvent-dev-dataplane.rudderstack.com';
const DATA_PLATFORM_URL_PROD = 'https://cvent-prod-dataplane.rudderstack.com';

function initAnalytics() {
    const hostName = window?.location?.hostname || '';
    const isHostApp = hostName.startsWith('app.');

    if (isHostApp) {
        const { environmentName, isEu, isPr, isDv } = getEnvironmentName();
        let writeKey = getEnvVar('CDP_USER_WRITE_KEY_DEV');
        if (isPr) {
            writeKey = isEu ? getEnvVar('CDP_USER_WRITE_KEY_PROD_EU') : getEnvVar('CDP_USER_WRITE_KEY_PROD');
        }
        const dataPlaneUrl = isPr ? DATA_PLATFORM_URL_PROD : DATA_PLATFORM_URL_DEV;

        const config = {
            customerDataPlatform: {
                writeKey,
                dataPlaneUrl,
            },
            globalActionProperties: {
                environmentName,
                appVersion: getEnvVar('REACT_APP_VERSION'),
                businessUnit: BUSINESS_UNIT,
                product: PRODUCT,
                component: DD_HOST_SERVICE_NAME,
            },
            pageTracking: true,
            // worker should be false because we got CSP error.
            // https://cvent.slack.com/archives/C04HD6QEPNW/p1755196352829809?thread_ts=1755025366.266859&cid=C04HD6QEPNW
            worker: false,
            defaultDestinations: ['Mixpanel', 'Gainsight PX'],
            disabled: isDv || __TESTING__,
            onReady: () => {
                LOG.debug('CDP Initialized and is ready.');
                const user = getBootstrap().get('user', {});
                const organization = getBootstrap().get('organization', {});
                const cdpUser = {
                    platformUserId: user.id,
                    email: user.email,
                    firstName: user.first_name,
                    lastName: user.last_name,
                    company: organization.name,
                    persona: 'planner',
                    isCVIIUser: false,
                };
                const cdpGroup = {
                    id: organization.salesforceAccountId,
                };
                analytics.identify(cdpUser, cdpGroup);
                LOG.debug('CDP user identified.', { user: cdpUser, group: cdpGroup });
            },
            onError: (err) => {
                LOG.debug('Error on CDP:', err);
            },
        };
        analytics.init(config);
    }
}

export const setAnalyticsGlobalProperties = (props) => {
    try {
        analytics.updateGlobalActionProperties({ ...props });
        LOG.debug('CDP set global props:', { ...props });
    } catch (err) {
        LOG.debug('Error on set global props', err);
    }
};

// Initialize analytics once import the file.
initAnalytics();
